'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { createFragmentContainer, graphql } = require('react-relay/compat');
const get = require('lodash.get');
const { FormattedMessage, FormattedRelative, FormattedNumber } = require('react-intl');

function Expiration({ expirationDate }) {
    const relativeDate = <FormattedRelative value={expirationDate} />;
    return (
        <div className="pdp-sidebar-hold-countdown">
            <FormattedMessage
                id="pdp.PrivateOffer.privateOfferExpires"
                defaultMessage="Offer expires {date}"
                values={{ date: relativeDate }}
            />
        </div>
    );
}

Expiration.propTypes = {
    expirationDate: PropTypes.string.isRequired,
};

function renderQuantityDisplay(quantityDisplay) {
    if (quantityDisplay) {
        return ` ${quantityDisplay}`;
    }
    return null;
}

function PrivateOffer({ conversation, currency, pdpBundleEnabled }) {
    const isPrivateOffer = get(conversation, 'transaction.isPrivateOffer');

    if (!isPrivateOffer || !pdpBundleEnabled) {
        return null;
    }

    const offerAmount = (
        get(conversation, 'transaction.mostRecentOffer.amountPerItem.convertedAmountList') || []
    ).find(amount => get(amount, 'currency') === currency);
    const formattedOfferAmount = (
        <span className="pdp-sidebar-private-offer-amount">
            <FormattedNumber value={offerAmount.amount} style="currency" currency={currency} />
        </span>
    );

    const expirationDate = get(conversation, 'transaction.mostRecentOffer.expirationDate');

    const quantityDisplay = get(conversation, 'item.displayInfo.pricing.quantityDisplay');
    //don't show private offer expiration if hold expiration is already showing
    const showExpiration = expirationDate && !get(conversation, 'relevantItemHold.expirationDate');

    return (
        <div className="pdp-sidebar-private-offer">
            <FormattedMessage
                id="pdp.PrivateOffer.privateOfferInfo"
                defaultMessage="{amount} Private Offer"
                values={{
                    amount: formattedOfferAmount,
                }}
            />
            {renderQuantityDisplay(quantityDisplay)}
            {showExpiration && <Expiration expirationDate={expirationDate} />}
        </div>
    );
}

PrivateOffer.propTypes = {
    conversation: PropTypes.object,
    currency: PropTypes.string,
    pdpBundleEnabled: PropTypes.bool,
};

module.exports = createFragmentContainer(PrivateOffer, {
    conversation: graphql`
        fragment PrivateOffer_conversation on Conversation {
            item {
                displayInfo(page: pdp) {
                    pricing {
                        quantityDisplay
                    }
                }
            }
            hasActiveHoldForBuyer
            relevantItemHold {
                expirationDate
            }
            transaction {
                isPrivateOffer
                mostRecentOffer {
                    expirationDate
                    amountPerItem {
                        convertedAmountList {
                            currency
                            amount
                        }
                    }
                }
            }
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/PrivateOffer.jsx